import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import ConfigurationProvider from '../DataContexts/ConfigurationContext';
import PaymentModelSection from './PaymentModelSection';
import BonusTiersSection from './BonusTiersSection';
import LongTrackSection from './LongTrackSection';
import DiskPolicySection from './DiskPolicySection';
import ConfigSubscriptions from './ConfigSubscriptions';
import './ConfigurationPage.css';

const TAB_KEYS = ['pricebonus', 'ondisk', 'subscriptions'];

const ConfigurationTabs = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [activeTab, setActiveTab] = useState(
    TAB_KEYS.includes(searchParams.get('tab')) ? searchParams.get('tab') : 'pricebonus'
  );

  useEffect(() => {
    const tab = searchParams.get('tab');
    if (TAB_KEYS.includes(tab)) {
      setActiveTab(tab);
    }
  }, [searchParams]);

  // Same pattern as PlaylistHeader (DJB-80): record the tab in the URL so a
  // refresh or shared link stays on the same sub-page
  const openTab = (tab) => {
    setActiveTab(tab);
    setSearchParams(
      (prev) => {
        const next = new URLSearchParams(prev);
        next.set('tab', tab);
        return next;
      },
      { replace: true }
    );
  };

  return (
    <div className="configuration-page">
      <div className="tab-container">
        <button
          className={`tab ${activeTab === 'pricebonus' ? 'active' : ''}`}
          onClick={() => openTab('pricebonus')}
        >
          Price &amp; Bonus Config
        </button>
        <button
          className={`tab ${activeTab === 'ondisk' ? 'active' : ''}`}
          onClick={() => openTab('ondisk')}
        >
          OnDisk Policy Config
        </button>
        <button
          className={`tab ${activeTab === 'subscriptions' ? 'active' : ''}`}
          onClick={() => openTab('subscriptions')}
        >
          Config Subscriptions
        </button>
      </div>
      <div className="tab-content configuration-tab-content">
        {/* DJB-176: the Mobile Pay Tiers overview is gone — payconiq slots
            are shown/created in the Paymentmodel section */}
        {activeTab === 'pricebonus' && (
          <div className="config-sections">
            <PaymentModelSection />
            <BonusTiersSection />
            <LongTrackSection />
          </div>
        )}
        {activeTab === 'ondisk' && (
          <div className="config-sections">
            <DiskPolicySection />
          </div>
        )}
        {activeTab === 'subscriptions' && (
          // DJB-179: one Playlist-Subscriptions-style section per config
          // type, on the Dashboard 1800px width (supersedes the DJB-166
          // single section)
          <div className="config-sections">
            <ConfigSubscriptions />
          </div>
        )}
      </div>
    </div>
  );
};

// DJB-161..165: the provider is page-scoped, so visiting Configuration is
// what loads (and revisiting reloads) the payment/bonus/long-track/disk data
const ConfigurationPage = () => (
  <ConfigurationProvider>
    <ConfigurationTabs />
  </ConfigurationProvider>
);

export default ConfigurationPage;
